import { SITE_URL } from '../../constants'
import { buildCaseStudySchema } from '../../builders/caseStudy'
import { PageMeta } from '../../types'

const description =
  'SBIレミットの海外送金アプリ「SBI Remit アプリ」のリニューアル事例。Aitria（アイトリア）がUX/UIデザインから開発まで一気通貫で支援し、顧客ロイヤルティ向上と改修工数削減を同時に実現。多様なユーザーが迷わない体験設計の裏側を紹介します。'

const ogpImg = 'https://aitria.co.jp/images/img/cases/remit/ogp_remit.png'

export const remitPageMeta: PageMeta = {
  title:
    'SBIレミット株式会社 海外送金アプリを刷新し、ロイヤルティ向上と改修工数削減を実現 | 事例 | Aitria（アイトリア）',
  description,
  keyword: '事例 実績 金融アプリ クロスプラットフォーム開発 UX/UI改善',
  image: ogpImg,
  url: `${SITE_URL}/cases/remit/`,
}

export const remitSchema = buildCaseStudySchema({
  slug: 'remit',
  pageTitle: remitPageMeta.title,
  description: remitPageMeta.description,
  headline: '海外送金アプリを刷新し、ロイヤルティ向上と改修工数削減を実現',
  alternativeHeadline: 'SBIレミット株式会社',
  primaryImage: ogpImg,
  images: [
    ogpImg,
    'https://aitria.co.jp/images/img/cases/remit/mv.webp',
  ],
  clientName: 'SBIレミット株式会社',
  breadcrumbLabel: '海外送金アプリを刷新し、ロイヤルティ向上と改修工数削減を実現',
})
